module.exports = __webpack_public_path__ + "media/custom/images/pocstock-about-us-collage-3-35353322c37472251a580464d2499119.png";